import HorizontalDivider from "plos/src/components/HorizontalDivider";
import ButtonLink from "plos/src/components/links/ButtonLink";
import { useTranslation } from "react-i18next";
import { ControlArrowRight } from "../../../icons/Arrows";

const DefaultTeamSavedContent = () => {
  const { t } = useTranslation("pickTeam");
  return (
    <>
      <h3>{t("teamSaved", "Team Saved")}</h3>
      <p>
        {t(
          "defaultTeamSaved.p1",
          "Dive into your leagues to track your performance, compare and see how you measure up against other managers.",
        )}
      </p>
      <HorizontalDivider />
      <ButtonLink to="../leagues" size="small">
        {t("viewMyLeagues", "View my Leagues")}
        <ControlArrowRight />
      </ButtonLink>
    </>
  );
};

export default DefaultTeamSavedContent;
